module.exports = __webpack_public_path__ + "static/img/EN.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/EN.png
// module id = 9cay
// module chunks = 1